import { notification } from 'antd';

export const Notification = (type, message) => {
    notification[type]({
        description: message,
        className: 'custom-toast-' + type,
    });
};